import type { InventoryRow } from '../types/inventoryRow';

export interface BoxMartinInventoryIdentity {
  reference: string;
  nom: string;
  stock: string;
}

/** Champs partagés de l’inventaire Box Martin — Neuilly (INV-2026-001). */
const BOX_MARTIN_NEUILLY_SHARED_FIELDS = {
  dateCreation: '2026-05-01',
  dateMiseAJour: '2026-05-03',
  site: 'Auchan Neuilly sur marne',
  superviseur: 'Claire Dubois',
  inventoriste: 'Nicolas Petit',
  ouvertPar: 'Jean-Baptiste Martinelli',
  emplacement: 'A1-B2-03',
  nombreArticles: 38,
  quantiteTheorique: 120,
  quantiteComptee: 114,
  sommePaHt: 3280.5,
  sommePvTtc: 5890.9,
  ecart: -6,
  statut: 'En cours' as const,
  dateComptage: '',
};

export const BOX_MARTIN_NEUILLY_INVENTORIES: BoxMartinInventoryIdentity[] = [
  {
    reference: 'INV-2026-001',
    nom: 'Inventaire Box Martin — Neuilly',
    stock: 'Box de Martin',
  },
  {
    reference: 'INV-2026-007',
    nom: 'Inventaire Fiscal 26 de Pierre',
    stock: 'Box de Pierre',
  },
  {
    reference: 'INV-2026-008',
    nom: 'Inventaire Box Amélie — Neuilly',
    stock: "Box d'Amélie",
  },
  {
    reference: 'INV-2026-009',
    nom: 'Inventaire Box Lucas — Neuilly',
    stock: 'Box de Lucas',
  },
];

export const BOX_MARTIN_NEUILLY_ADDITIONAL_INVENTORIES = BOX_MARTIN_NEUILLY_INVENTORIES.filter(
  (inventory) => inventory.reference !== 'INV-2026-001',
);

export function isBoxMartinNeuillyInventory(reference: string): boolean {
  return BOX_MARTIN_NEUILLY_INVENTORIES.some((inventory) => inventory.reference === reference);
}

export function getBoxMartinNeuillyIdentity(
  reference: string,
): BoxMartinInventoryIdentity | undefined {
  return BOX_MARTIN_NEUILLY_INVENTORIES.find((inventory) => inventory.reference === reference);
}

export function createBoxMartinNeuillyInventoryRow(identity: BoxMartinInventoryIdentity): InventoryRow {
  return {
    reference: identity.reference,
    nom: identity.nom,
    stock: identity.stock,
    ...BOX_MARTIN_NEUILLY_SHARED_FIELDS,
  };
}

export function getBoxMartinNeuillyInventoryHeader(reference: string): {
  reference: string;
  nom: string;
  site: string;
  stock: string;
  superviseur: string;
  inventoriste: string;
  statut: 'En cours';
} | undefined {
  const identity = getBoxMartinNeuillyIdentity(reference);

  if (!identity) {
    return undefined;
  }

  return {
    reference: identity.reference,
    nom: identity.nom,
    site: BOX_MARTIN_NEUILLY_SHARED_FIELDS.site,
    stock: identity.stock,
    superviseur: BOX_MARTIN_NEUILLY_SHARED_FIELDS.superviseur,
    inventoriste: BOX_MARTIN_NEUILLY_SHARED_FIELDS.inventoriste,
    statut: BOX_MARTIN_NEUILLY_SHARED_FIELDS.statut,
  };
}
